/**
 * @author: lv.chen
 * @date: 2025/10/9
 * @desc: 季报页面二维码组件
 */
import React from 'react';
import classnames from 'classnames';
import Image from '@user-center/components/Image';

import './index.scss';

import IMG_SCAN from '@user-center/assets/images/quarter-report/erweima.png';

interface IQRCodeProps extends IBaseProps {}

const QRCode: React.FC<IQRCodeProps> = (props) => {
  const { style, className } = props;

  return (
    <div style={style} className={classnames('dbu-quarter-report-qrcode', className)}>
      <div className="dbu-quarter-report-qrcode__frontend-bg">
        <Image className="dbu-quarter-report-qrcode__img" src={IMG_SCAN} alt="" />
      </div>
      <div className="dbu-quarter-report-qrcode__backend-bg"></div>
    </div>
  );
};

export default QRCode;
